import React, { useState } from "react";
import { Button } from "primereact/button";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { SelectButton } from "primereact/selectbutton";
import { Link } from "react-router-dom";

// List of public domains not allowed
const publicDomains = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "outlook.com",
  "aol.com",
  "icloud.com",
];

// Utility function to validate business email format
const isValidEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(email)) return false;
  const domain = email.split("@")[1].toLowerCase();
  return !publicDomains.includes(domain);
};

// List of countries
const countryList = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Ivory Coast",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea (North)",
  "Korea (South)",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

// List of European countries
const europeanCountries = [
  "Albania",
  "Andorra",
  "Armenia",
  "Austria",
  "Azerbaijan",
  "Belarus",
  "Belgium",
  "Bosnia and Herzegovina",
  "Bulgaria",
  "Croatia",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Estonia",
  "Finland",
  "France",
  "Georgia",
  "Germany",
  "Greece",
  "Hungary",
  "Iceland",
  "Ireland",
  "Italy",
  "Kosovo",
  "Latvia",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Malta",
  "Moldova",
  "Monaco",
  "Montenegro",
  "Netherlands",
  "North Macedonia",
  "Norway",
  "Poland",
  "Portugal",
  "Romania",
  "Russia",
  "San Marino",
  "Serbia",
  "Slovakia",
  "Slovenia",
  "Spain",
  "Sweden",
  "Switzerland",
  "Turkey",
  "Ukraine",
  "United Kingdom",
  "Vatican City",
];

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal visibility
  const [email, setEmail] = useState(""); // Email input
  const [consent, setConsent] = useState(false); // Consent checkbox

  const [technology, setTechnology] = useState("4G"); // Selected technology
  const [environment, setEnvironment] = useState("Indoor"); // Selected environment
  const [deploymentModel, setDeploymentModel] = useState("On-Prem"); // Selected deployment model

  const [isSubmitted, setIsSubmitted] = useState(false); // State for form submission
  const [showPricing, setShowPricing] = useState(false); // Show pricing after submit
  const [optionalInfo, setOptionalInfo] = useState({
    country: "",
    industry: "",
    indoorArea: "",
    outdoorArea: "",
    longitude: "",
    latitude: "",
    supportUpgrade: "Basic",
    edgeComputing: "No",
    floorPlan: null,
  });

  const technologyOptions = ["4G", "5G", "4G+5G"]; // Technology options
  const environmentOptions = ["Indoor", "Outdoor", "Both"]; // Environment options
  const deploymentOptions = ["On-Prem", "Cloud"]; // Deployment Model options

  // Pricing Data for various combinations (Simplified for demo purposes)
  const pricingData = {
    "4G": {
      Indoor: {
        "On-Prem": { price: "€11200.99", yearly: "€1299.15" },
        Cloud: { price: "€14000.00", yearly: "€1599.99" },
      },
      Outdoor: {
        "On-Prem": { price: "€13000.99", yearly: "€1399.15" },
        Cloud: { price: "€15000.00", yearly: "€1799.99" },
      },
    },
    "5G": {
      Indoor: {
        "On-Prem": { price: "€15000.99", yearly: "€2299.15" },
        Cloud: { price: "€18000.00", yearly: "€2799.99" },
      },
      Outdoor: {
        "On-Prem": { price: "€17000.99", yearly: "€2399.15" },
        Cloud: { price: "€20000.00", yearly: "€2999.99" },
      },
    },
  };

  // Handle form submission
  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (isValidEmail(email) && consent) {
      const existingData =
        JSON.parse(localStorage.getItem("flexnetConfig")) || {};

      const formData = {
        ...existingData,
        email,
      };

      localStorage.setItem("flexnetConfig", JSON.stringify(formData));
      setIsModalOpen(false); // Close modal if valid
    } else {
      alert(
        "Please enter a valid business email and accept the consent checkbox."
      );
    }
  };

  // Handle the second form submission (Technology, Environment, Deployment Model)
  const handleFormSubmit2 = (e) => {
    e.preventDefault();
    if (technology && environment && deploymentModel) {
      const existingData =
        JSON.parse(localStorage.getItem("flexnetConfig")) || {};

      const formData2 = {
        ...existingData,
        technology,
        environment,
        deploymentModel,
      };

      localStorage.setItem("flexnetConfig", JSON.stringify(formData2));

      setShowPricing(true); // Show pricing after submit
      setIsSubmitted(true); // Mark the form as submitted
    } else {
      alert("Please select all fields.");
    }
  };

  // Handle optional info form submission
  const handleOptionalInfoSubmit = (e) => {
    e.preventDefault();
    const existingData =
      JSON.parse(localStorage.getItem("flexnetConfig")) || {};

    const optionalFormData = {
      ...existingData,
      optionalInfo,
    };

    localStorage.setItem("flexnetConfig", JSON.stringify(optionalFormData));

    alert(
      "Thank you for the additional information. We will review it and get back to you."
    );
  };

  const getPricingDetails = () => {
    if (technology && environment && deploymentModel) {
      const details = pricingData[technology]?.[environment]?.[deploymentModel];
      if (!details) {
        return <p>No pricing information available for this configuration.</p>;
      }
      return (
        <tr>
          <td>{technology}</td>
          <td>{environment}</td>
          <td>{deploymentModel}</td>
          <td>{details.price}</td>
          <td>{details.yearly}</td>
        </tr>
      );
    }
    return null;
  };

  const getImageForSelection = () => {
    // Choose an image based on the selection, for example:
    if (technology === "5G" && environment === "Indoor") {
      return "https://www.pngplay.com/wp-content/uploads/6/Computer-Accessories-Background-PNG-Image.png";
    } else if (technology === "4G" && environment === "Outdoor") {
      return "https://static.vecteezy.com/system/resources/previews/024/046/205/non_2x/black-mouse-computer-accessories-on-transparent-background-free-png.png";
    } else if (deploymentModel === "Cloud") {
      return "https://source.unsplash.com/600x400/?cloud,technology";
    }
    return "https://source.unsplash.com/600x400/?technology";
  };

  // Function to get message based on selected country
  const getCountryMessage = () => {
    const selectedCountry = optionalInfo.country;

    if (selectedCountry === "Germany") {
      return "Hello 1";
    } else if (selectedCountry === "United Kingdom") {
      return "Hello 2";
    } else if (europeanCountries.includes(selectedCountry)) {
      return "You are within our coverage.";
    } else {
      return "The local spectrum is not available for private networks. We will check possible options and get back to you.";
    }
  };

  return (
    <div className="container connectivity-main-page mx-auto px-6 py-10">
      {/* Modal for email and consent */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Enter Your Business Email</h2>
            <form onSubmit={handleFormSubmit}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter business email"
                required
              />
              <div>
                <input
                  type="checkbox"
                  id="consent"
                  checked={consent}
                  onChange={(e) => setConsent(e.target.checked)}
                />
                <label htmlFor="consent">
                  I agree to be contacted for communication purposes.
                </label>
              </div>
              <Button
                className=" connectivity-main-buttons"
                type="submit"
                label="Submit"
              />
            </form>
          </div>
        </div>
      )}

      {!isModalOpen && (
        <>
          <div>
            <h1 className="text-900 font-bold text-6xl mb-6 text-center">
              FlexNet Connectivity: Seamless, Secure, and Reliable
            </h1>
            <p className="text-700 text-xl mb-5 text-center line-height-3">
              FlexNet is a comprehensive private 4G/5G platform designed to meet
              the diverse needs of modern industries. It integrates
              connectivity, devices, and applications into a single solution,
              ensuring seamless operation across indoor, outdoor or portable
              setups.
            </p>
            <p className="text-700 text-xl mb-5 text-center line-height-3">
              With a focus on industrial-grade reliability, Edge Computing, and
              an extensive Marketplace, FlexNet simplifies complex connectivity
              challenges. Whether you're automating processes, enhancing worker
              safety, or driving digital transformation, FlexNet is the
              scalable, easy-to-deploy solution that keeps your operations
              running smoothly.
            </p>
            <span className="text-900 text-2xl  mb-5 text-center line-height-3">
              <button className="connectivity-request-demo-button">
                <Link className="">Request a Demo</Link>
              </button>
              and see how FlexNet can transform your operations.
            </span>
          </div>

          <div>
            <hr className="y-3 mx-0 border-top-1 border-bottom-none border-300 mt-7" />
            <h1 className="text-900 font-bold text-6xl mb-7 mt-7 text-center">
              What’s in FlexNet?
            </h1>
            <div>
              <h3 className="text-900 font-bold text-3xl mb-7 mt-7 text-center">
                FlexNet offers everything you need for a robust private network,
                all in one platform: Key Components
              </h3>

              <ul className="list-none p-0 m-0 flex-grow-1">
                <li className="flex align-items-center mb-3 text-700 text-xl">
                  <i className="pi pi-check-circle text-green-500 mr-2"></i>
                  <span className=" font-bold mr-1">Radio Unit: </span> A 4G or
                  5G system for indoor or outdoor use, tailored to predefined
                  spectrum options.
                </li>

                <li className="flex align-items-center mb-3 text-700 text-xl">
                  <i className="pi pi-check-circle text-green-500 mr-2"></i>
                  <span className=" font-bold mr-1">Server: </span> On-premises
                  hosting for core networks and industrial applications.
                  Optionally the core network and applications can be hosted in
                  Cloud.
                </li>

                <li className="flex align-items-center mb-3 text-700 text-xl">
                  <i className="pi pi-check-circle text-green-500 mr-2"></i>
                  <span className=" font-bold mr-1">SIM Card: </span>{" "}
                  Pre-configured FlexNet SIM Cards or eSIM ensure your devices
                  are connected and operational from day one.
                </li>
              </ul>
            </div>
            <div>
              <hr className="y-3 mx-0 border-top-1 border-bottom-none border-300 mt-7 mb-7" />

              <h3 className="text-900 font-bold text-3xl mb-7 mt-7 text-center">
                Enhanced Capabilities
              </h3>

              <ul className="list-none p-0 m-0 flex-grow-1">
                <li className="flex align-items-center mb-3 text-700 text-xl">
                  <i className="pi pi-check-circle text-green-500 mr-2"></i>
                  <span className=" font-bold mr-1">Edge Computing: </span>
                  Low-latency performance with local data processing.
                </li>
                <li className="flex align-items-center mb-3 text-700 text-xl">
                  <i className="pi pi-check-circle text-green-500 mr-2"></i>
                  <span className=" font-bold mr-1">Web-Based Management:</span>
                  Intuitive tools for easy monitoring and control.
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-900 font-bold text-3xl mb-7 mt-7 text-center">
                Marketplace Access
              </h3>

              <ul className="list-none p-0 m-0 flex-grow-1">
                <li className="flex align-items-center mb-3 text-700 text-xl">
                  <i className="pi pi-check-circle text-green-500 mr-2"></i>
                  <span className=" font-bold mr-1">FlexNet Marketplace:</span>
                  Access innovative apps and devices tailored to your industry’s
                  needs.
                </li>
              </ul>
            </div>
            <span className="text-900 text-2xl  mb-5 text-center line-height-3">
              <button className="connectivity-request-demo-button mt-5 ">
                <Link className="">Request a Demo</Link>
              </button>
              and see how FlexNet can transform your operations.
            </span>
          </div>

          <div>
            <hr className="y-3 mx-0 border-top-1 border-bottom-none border-300 mt-7" />
            <h1 className="text-900 font-bold text-6xl mb-7 mt-7 text-center">
              Security in FlexNet
            </h1>
            <div>
              <h3 className="text-900 font-bold text-3xl mb-7 mt-7 text-center">
                FlexNet provides robust security by default, adhering to 3GPP
                SIM-based standards for private 5G networks, ensuring encrypted
                communication, authentication, and data integrity. For
                organizations seeking enhanced protection, FlexNet offers
                additional advanced security options.
              </h3>

              <h3 className="text-900 font-bold text-3xl mb-7 mt-7 text-center">
                Default Security Features:
              </h3>
              <ul className="list-none p-0 m-0 flex-grow-1">
                <li className="flex align-items-center mb-3 text-700 text-xl">
                  <i className="pi pi-check-circle text-green-500 mr-2"></i>
                  <span className=" font-bold mr-1">
                    SIM-Based Authentication:
                  </span>
                  Ensures secure access to the network using EAP-AKA protocols
                  for device and user validation.
                </li>

                <li className="flex align-items-center mb-3 text-700 text-xl">
                  <i className="pi pi-check-circle text-green-500 mr-2"></i>
                  <span className=" font-bold mr-1">
                    3GPP Encryption Algorithms:
                  </span>
                  Secures communication between the core and radio units through
                  mutual authentication.
                </li>

                <li className="flex align-items-center mb-3 text-700 text-xl">
                  <i className="pi pi-check-circle text-green-500 mr-2"></i>
                  <span className=" font-bold mr-1">
                    IPSec Encryption (Optional):
                  </span>
                  Pre-configured FlexNet SIM Cards or eSIM ensure your devices
                  are connected and operational from day one.
                </li>
              </ul>
            </div>
            <div>
              <hr className="y-3 mx-0 border-top-1 border-bottom-none border-300 mt-7 mb-7" />

              <h3 className="text-900 font-bold text-3xl mb-7 mt-7 text-center">
                Enhanced Security with ZTNA
              </h3>
              <h3 className="text-900 font-bold text-3xl mb-7 mt-7 text-center">
                For advanced protection, FlexNet integrates Zero Trust Network
                Access (ZTNA):
              </h3>

              <ul className="list-none p-0 m-0 flex-grow-1">
                <li className="flex align-items-center mb-3 text-700 text-xl">
                  <i className="pi pi-check-circle text-green-500 mr-2"></i>
                  <span className=" font-bold mr-1">
                    Policy-Based Management:
                  </span>
                  Define granular access rules based on IP, location, or device
                  IMEI, limiting access to authorized users.
                </li>
                <li className="flex align-items-center mb-3 text-700 text-xl">
                  <i className="pi pi-check-circle text-green-500 mr-2"></i>
                  <span className=" font-bold mr-1">Micro-Segmentation: </span>
                  Isolate network segments to contain potential breaches and
                  prevent unauthorized lateral movement.
                </li>
                <li className="flex align-items-center mb-3 text-700 text-xl">
                  <i className="pi pi-check-circle text-green-500 mr-2"></i>
                  <span className=" font-bold mr-1">
                    Traffic Analytics and QoS:
                  </span>
                  Monitor, prioritize, and optimize traffic to support critical
                  applications securely.
                </li>
              </ul>
            </div>

            <h3 className="text-900 font-bold text-3xl mb-7 mt-7 text-center">
              FlexNet ensures that your private 5G network remains secure,
              reliable, and tailored to your organization’s needs.
            </h3>

            <span className="text-900 text-2xl  mb-5 text-center line-height-3">
              <button className="connectivity-request-demo-button">
                <Link className="">Request a Demo</Link>
              </button>
              and see how FlexNet can transform your operations.
            </span>
          </div>

          <div>
            <hr className="y-3 mx-0 border-top-1 border-bottom-none border-300 mt-7" />
            <h3 className="text-900 font-bold text-3xl mb-2 mt-7 text-center">
              FlexNet Plans
            </h3>

            <div className="overflow-x-auto p-4">
              <table className="w-full border border-gray-300 text-left">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border border-gray-300 px-4 py-2"></th>
                    <th className="border border-gray-300 px-4 py-2 font-semibold">
                      FlexNet Cloud
                    </th>
                    <th className="border border-gray-300 px-4 py-2 font-semibold">
                      FlexNet On-Prem Plus
                    </th>
                    <th className="border border-gray-300 px-4 py-2 font-semibold">
                      FlexNet Portable
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    {
                      feature: "Deployment",
                      values: [
                        "Cloud-hosted",
                        "On-premises",
                        "Backpack or COW",
                      ],
                    },
                    {
                      feature: "Technology",
                      values: ["4G/5G", "4G/5G", "4G/5G"],
                    },
                    {
                      feature: "Environment",
                      values: [
                        "Indoor/Outdoor",
                        "Indoor/Outdoor",
                        "Indoor/Outdoor",
                      ],
                    },
                    {
                      feature: "Core Network",
                      values: ["Cloud", "On-premises", "On-premises"],
                    },
                    { feature: "SIM/eSIM", values: ["50", "50", "50"] },
                    {
                      feature: "Edge Computing",
                      values: ["Optional", "Included", "Included"],
                    },
                    {
                      feature: "Support",
                      values: [
                        "8x5 (Included)",
                        "8x5 (Included)",
                        "8x5 (Included)",
                      ],
                    },
                    {
                      feature: "Pricing",
                      values: ["From €499/mo", "From €499/mo", "From €499/mo"],
                    },
                  ].map((row, index) => (
                    <tr
                      key={index}
                      className={`${
                        index % 2 === 0 ? "bg-blue-100" : "bg-white"
                      }`}
                    >
                      <td className="border border-gray-300 px-4 py-2 font-semibold">
                        {row.feature}
                      </td>
                      {row.values.map((value, idx) => (
                        <td
                          key={idx}
                          className="border border-gray-300 px-4 py-2"
                        >
                          {value}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <h3 className="text-900 font-bold text-3xl mb-7 mt-7 text-center">
              FlexNet ensures that your private 5G network remains secure,
              reliable, and tailored to your organization’s needs.
            </h3>

            <span className="text-900 text-2xl  mb-5 text-center line-height-3">
              <button className="connectivity-request-demo-button">
                <Link className="">Request a Demo</Link>
              </button>
              and see how FlexNet can transform your operations.
            </span>
          </div>

          <div>
            <hr className="y-3 mx-0 border-top-1 border-bottom-none border-300 mt-7" />
            <h1 className="text-900 font-bold text-6xl mb-7 mt-7 text-center">
              Why Choose FlexNet?
            </h1>
            <div>
              <h3 className="text-900 font-bold text-3xl mb-2 mt-7 text-center">
                Activate in Minutes
              </h3>
              <p className="text-700 text-xl mb-5 text-center line-height-3">
                FlexNet provides a plug-and-play solution that can be deployed
                in under 30 minutes, letting you focus on operations rather than
                complex setups.
              </p>

              <h3 className="text-900 font-bold text-3xl mb-2 mt-7 text-center">
                DIY System Integration
              </h3>
              <p className="text-700 text-xl mb-5 text-center line-height-3">
                Easily configure and manage your network with intuitive,
                self-service tools—no telecom expertise required.
              </p>

              <h3 className="text-900 font-bold text-3xl mb-2 mt-7 text-center">
                Marketplace for Innovation
              </h3>
              <p className="text-700 text-xl mb-5 text-center line-height-3">
                Access tailored apps, devices, and solutions in the FlexNet
                Marketplace to drive efficiency and innovation for your
                business.
              </p>
              <h3 className="text-900 font-bold text-3xl mb-2 mt-7 text-center">
                Industrial-Grade Reliability
              </h3>
              <p className="text-700 text-xl mb-5 text-center line-height-3">
                Designed for mission-critical operations, FlexNet ensures
                consistent, secure, and high-speed connectivity across indoor
                and outdoor environments.
              </p>
              <h3 className="text-900 font-bold text-3xl mb-2 mt-7 text-center">
                Transparent Pricing
              </h3>
              <p className="text-700 text-xl mb-5 text-center line-height-3">
                Enjoy cost-effective solutions with no hidden fees, all
                delivered through a Network-as-a-Service (NaaS) model starting
                at just €499/month.
              </p>

              <h3 className="text-900 font-bold text-5xl mb-2 mt-7 text-center">
                Discover FlexNet Today
              </h3>
            </div>

            <h3 className="text-900 font-bold text-3xl mb-7 mt-7 text-center">
              Ready to experience seamless connectivity?
            </h3>

            <span className="text-900 text-2xl  mb-5 text-center line-height-3">
              <button className="connectivity-request-demo-button">
                <Link className="">Request a Demo</Link>
              </button>
              and see how FlexNet can transform your operations.
            </span>

            <div className="flexnet-box-img">
              <img src="/flexnet-box.png" alt="flexnet-box" />
              <img src="/flexnet-car.png" alt="flexnet-car" />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default App;
